import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  aliquotRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));
